// extracted by mini-css-extract-plugin
export default {"folder":"Folder_folder__W6Hsp","mainContent":"Folder_mainContent__MJljK","bottom":"Folder_bottom__H7evM","main":"Folder_main__m17k3"};